import type { CSSProperties } from 'react';
import { Outlet } from 'react-router';
import { SessionExpiredBanner } from '@/features/auth/components/session-expired-banner';
import { SidebarProvider } from '@/shared/ui/sidebar/sidebar-provider';
import { AppHeader } from '../navigation/app-header';
import { AppSidebar } from '../navigation/app-sidebar';
import { BottomNav } from '../navigation/bottom-nav';
import { MobileHeader } from '../navigation/mobile-header';
import { ShellFooter } from '../navigation/shell-footer';
import { useSidebarOpen } from './use-sidebar-open';

/**
 * Desktop: a shell sharing the sidebar's background — collapsible sidebar, header (breadcrumb,
 * theme, language), footer (sync, version) — around the page, the only bordered surface, which
 * scrolls on its own. Phones: a short sticky header, the page, and the bottom bar.
 */
export function AppLayout() {
  const [open, setOpen] = useSidebarOpen();
  return (
    <SidebarProvider
      open={open}
      onOpenChange={setOpen}
      className="md:h-svh md:overflow-hidden md:bg-sidebar"
      style={{ '--sidebar-width': '15rem' } as CSSProperties}
    >
      <AppSidebar />
      <div className="flex min-w-0 flex-1 flex-col md:h-svh">
        <AppHeader />
        <MobileHeader />
        <SessionExpiredBanner />
        <main className="min-w-0 flex-1 pb-[calc(9rem+env(safe-area-inset-bottom))] md:min-h-0 md:pr-2 md:pb-0">
          <div className="md:h-full md:overflow-y-auto md:rounded-xl md:border md:bg-background md:shadow-xs">
            <Outlet />
          </div>
        </main>
        <ShellFooter className="hidden md:flex" />
      </div>
      <BottomNav />
    </SidebarProvider>
  );
}
